import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ProjectsSection from '../components/ProjectsSection';
import SkillsSection from '../components/SkillsSection';
import VisionSection from '../components/VisionSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import MatrixRain from '../components/MatrixRain';

const Portfolio = () => {
  return (
    <div className="relative min-h-screen text-white overflow-hidden">

      {/* 🔥 PURE BLACK BASE LAYER */}
      <div className="fixed inset-0 bg-black z-0"></div>

      {/* 🔥 MATRIX LAYER (ABOVE BLACK) */}
      <div className="fixed inset-0 z-[1]">
        <MatrixRain />
      </div>

      {/* 🔥 CONTENT LAYER (TOP) */}
      <div className="relative z-10">
        <Header />

        <main>
          <HeroSection />
          <AboutSection />
          <ProjectsSection />
          <SkillsSection />
          <VisionSection />
          <ContactSection />
        </main>

        <Footer />
      </div>

    </div>
  );
};

export default Portfolio;